export default function useRevenueFromSearch() {
  return true
}
